/** removes any non letter, number and whitespace */
const removeInvalidPhoneChars = (anyString: string) =>
  anyString.replace(/[^A-Z0-9]+/gim, '')

/** Cases:
 *
 * - number starts with +, do nothing
 * - phoneNum starts with any number other than 0, place just '+' (eg. 35842345235 --> +35842345235)
 * - number starts with 00, replace 00 with + (0049 --> +49)
 * - phoneNum starts with 0 and not 00, FI number --> replace with +358
or it starts with a 0 and needs the finnish country code with plus */
const addPlusOrFiCountryCode = (phoneNumber: string) =>
  phoneNumber.charAt(0) === '+'
    ? phoneNumber
    : phoneNumber.charAt(0) !== '0'
    ? `+${phoneNumber}`
    : phoneNumber.charAt(0) === '0' && phoneNumber.charAt(1) === '0'
    ? phoneNumber.replace('00', '+')
    : phoneNumber.charAt(0) === '0'
    ? phoneNumber.replace('0', '+358')
    : phoneNumber

const formatPhoneNumForCognito = (phoneNumber: string) =>
  addPlusOrFiCountryCode(removeInvalidPhoneChars(phoneNumber))

export { formatPhoneNumForCognito }
